module.exports = __webpack_public_path__ + "static/img/19023B_5_6_C_20230520_LC.93663b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19023B_5_6_C_20230520_LC.png
// module id = a6Bd
// module chunks = 0